
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cities/[category]",
      function () {
        return require("private-next-pages/cities/[category]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cities/[category]"])
      });
    }
  